module.exports = __webpack_public_path__ + "static/spray-c55e80d5f2154e1ece29f9d3453440ba.png";